import { Body, StyledTypographyDateValue } from '@components/TicketBox/styled'
import { Box, Typography } from '@mui/material'
import { formatDate } from '@utils/time'
import { DotsWrapper } from '@components/common'
import { TicketCounterStatuses } from '@appTypes/enums/filters'
import { ViewComponentsProps } from '@components/TicketBox/types'
import Courses from '../Courses'
import Members from '../Members'
import RequestedAtRender from '../RequestedAtRender'

const HistoryTicketsView = ({ page, date, ticket }: ViewComponentsProps) => {
  const { status, offerStatus, availability, comment } = ticket
  return (
    <Body page={page}>
      <RequestedAtRender ticket={ticket} availability={availability} />
      <Courses page={page} ticket={ticket} />
      <Box>
        <Typography component='h5' variant='h5'>
          Date and Time
        </Typography>
        <StyledTypographyDateValue>
          {!(
            offerStatus === TicketCounterStatuses.PENDING ||
            offerStatus === TicketCounterStatuses.NO_OFFER)
            ?
            (
              <>
                {date.format('MMM D, YYYY (dddd)')} {date.format('hh:mm A')}
              </>
            )
            :
            (
              <>
                {date.format('MMM D, YYYY (dddd)')} {date.format('hh:mm A')}
              </>
            )}
        </StyledTypographyDateValue>
      </Box>
      <Members ticket={ticket} />
      <Box>
        <Typography component='h5' variant='h5'>
          Comments
        </Typography>
        <DotsWrapper>
          <Typography component='p'>{comment}</Typography>
        </DotsWrapper>
      </Box>
    </Body>
  )
}

export default HistoryTicketsView
